module.exports = __webpack_public_path__ + "img/navigation-previous-alternate.9ee63950.svg";